import { authInterceptorModule } from '../../../shared/app/interceptors/auth-interceptor/auth-interceptor';
import { embedded } from './embedded';

export const authInterceptorConfigModule = angular
  .module('Q.config.auth-interceptor', [authInterceptorModule.name])

  .config(function (authInterceptorProvider) {
    // if this page is embedded, then we need to use the embedded authorization mode. Due to 3rd party cookie
    // restrictions, we cannot set or rely on server-set cookies.
    authInterceptorProvider.setMode(embedded ? 'embed' : 'candidate');
  });
